<template>
  <div class="zw-aboutus">
    <!--大图-->
    <div class="zw-aboutus-bgImg" :style="{backgroundImage:'url('+ pictureBaseUrl + picUrl +')'}">
      <div class="zw-aboutus-bgImg-content">
        <p style="color: #ffffff">关于我们</p>
        <span style="color: #ffffff;margin-top: 10px">一切为了客户 以客户为中心</span>
      </div>
    </div>
    <!--导航栏 -->
    <div class="zw-aboutus-context">

      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane label="公司介绍" name="1">
          <ul class="zw-aboutus-list">
            <!--公司介绍-->
            <li class="zw-aboutus-list-corp">
              <p class="zw-corp-title">鑫众为软件：专注信息化建设、智能化转型的管理软件供应商</p>
              <span class="zw-corp-division" />
              <ul class="zw-corp-context">
                <li v-for="(item, index) in corpList" :key="index">
                  {{ item.context }}
                </li>
                <li v-for="(item, index) in corpListBold" :key="index" style="font-weight:bold">
                  {{ item.context }}
                </li>
              </ul>
              <div style="display: flex;justify-content: center">
                <img src="../assets/img/corpImg.png" width="50%" alt="">
              </div>
            </li>
            <li class="zw-aboutus-list-brief">
              <ul class="zw-brief-list">
                <li>
                  <span class="zw-brief-list-title">20年</span>
                  <div>
                    <span class="zw-brief-list-context">
                      累计行业沉淀
                    </span>
                  </div>
                </li>
                <el-divider direction="vertical" />
                <li>
                  <span class="zw-brief-list-title" style="">300+</span>
                  <div>
                    <span class="zw-brief-list-context">
                      长期合作伙伴
                    </span>
                  </div>
                </li>
                <el-divider direction="vertical" />
                <li>
                  <span class="zw-brief-list-title">190+</span>
                  <div>
                    <span class="zw-brief-list-context">
                      资深团队成员
                    </span>
                  </div>
                </li>
              </ul>
            </li>
            <!--服务理念-->
            <li class="zw-aboutus-list-idea">
              <div class="zw-idea-title">服务理念</div>
              <div class="zw-idea-list">
                <div class="zw-idea-left">
                  <img src="../assets/img/yxfwkhzs.png" width="50%" alt="">
                  <div class="zw-idea-left-title">
                    <p>一切为了客户</p>
                    <p>以客户为中心</p>
                  </div>
                  <span>我们通过更专业的服务，做到积极响应、快速行动、首问负责、跟踪落实彻底解决。</span>
                </div>
                <ul class="zw-idea-right">
                  <li v-for="(item,index) in ideaList" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <p>{{ item.title }}</p>
                    <span>{{ item.context }}</span>
                  </li>
                </ul>
              </div>
            </li>
            <!--发展历程-->
            <li class="zw-aboutus-list-develop">
              <div class="zw-develop-title">发展历程</div>
              <ul class="zw-develop-context">
                <timeLine />
              </ul>
              <!--              <div class="zw-develop-btn">-->
              <!--                <el-button-->
              <!--                  style="width: 180px"-->
              <!--                  type="info"-->
              <!--                  plain-->
              <!--                  icon="el-icon-arrow-left"-->
              <!--                  @click="handleLastYear"-->
              <!--                >上一年</el-button>-->
              <!--                <el-button-->
              <!--                  style="width: 180px"-->
              <!--                  type="info"-->
              <!--                  plain-->
              <!--                  @click="handleNextYear"-->
              <!--                >下一年-->
              <!--                  <i class="el-icon-arrow-right el-icon&#45;&#45;right" />-->
              <!--                </el-button>-->
              <!--              </div>-->
            </li>
            <!--荣誉资质-->
            <li class="zw-aboutus-honor">
              <div class="zw-honor-title">荣誉资质</div>
              <div class="zw-honor-carousel">
                <el-carousel trigger="click" height="260px" indicator-position="outside" :interval="-1">
                  <el-carousel-item v-for="(item, index) in honorList" :key="index">
                    <ul class="zw-carousel-list">
                      <li v-for="(itemChild, indexChild) in item" :key="indexChild">
                        <div>
                          <el-image :src="pictureBaseUrl + itemChild.imgUrl" style="height: 140px;" alt="" :preview-src-list="srcList" />
                        </div>
                        <span style="padding-top: 20px">
                          {{ itemChild.name }}
                        </span>
                      </li>
                    </ul>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </li>
            <!--联系我们-->
            <li class="zw-aboutus-contact">
              <div class="zw-contact-title">联系我们</div>
              <div class="zw-contact-context">
                <div class="zw-contact-left">
                  <img src="../assets/img/lxwmImg.png" width="100%" alt="">
                </div>
                <ul class="zw-contact-right">
                  <li>
                    公司地址: <span>西安市丈八一路一号汇鑫IBC(A座)806室</span>
                  </li>
                  <li>
                    联系电话: <span>029-89181990</span>
                  </li>
                  <li>
                    公司邮箱: <span>info@zhongway.com</span>
                  </li>
                  <li>
                    公司邮编: <span>710065</span>
                  </li>
                  <li>
                    公司网址: <span>www.zhongway.com</span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="服务理念" name="2">
          <ul class="zw-aboutus-list">
            <!--服务理念-->
            <li class="zw-aboutus-list-idea">
              <div class="zw-idea-title">服务理念</div>
              <div class="zw-idea-list">
                <div class="zw-idea-left">
                  <img src="../assets/img/yxfwkhzs.png" width="50%" alt="">
                  <p>用心服务  客户至上</p>
                  <span>我们通过更专业的服务，做到积极响应、快速行动、首问负责、跟踪落实彻底解决。</span>
                </div>
                <ul class="zw-idea-right">
                  <li v-for="(item,index) in ideaList" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <p>{{ item.title }}</p>
                    <span>{{ item.context }}</span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="发展历程" name="3">
          <ul class="zw-aboutus-list">
            <!--发展历程-->
            <li class="zw-aboutus-list-develop">
              <div class="zw-develop-title">发展历程</div>
              <ul class="zw-develop-context">
                <timeLine />
              </ul>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="荣誉资质" name="4">
          <ul class="zw-aboutus-list">
            <!--荣誉资质-->
            <li class="zw-aboutus-honor">
              <div class="zw-honor-title">荣誉资质</div>
              <div class="zw-honor-carousel">
                <el-carousel trigger="click" height="260px" indicator-position="outside" :interval="-1">
                  <el-carousel-item v-for="(item, index) in honorList" :key="index">
                    <ul class="zw-carousel-list">
                      <li v-for="(itemChild, indexChild) in item" :key="indexChild">
                        <div>
                          <el-image :src="pictureBaseUrl + itemChild.imgUrl" style="height: 140px;" alt="" :preview-src-list="srcList" />
                        </div>
                        <span style="padding-top: 20px">
                          {{ itemChild.name }}
                        </span>
                      </li>
                    </ul>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="联系我们" name="5">
          <ul class="zw-aboutus-list">
            <!--联系我们-->
            <li class="zw-aboutus-contact">
              <div class="zw-contact-title">联系我们</div>
              <div class="zw-contact-context">
                <div class="zw-contact-left">
                  <img src="../assets/img/lxwmImg.png" width="100%" alt="">
                </div>
                <ul class="zw-contact-right">
                  <li>
                    公司地址: <span>西安市丈八一路一号汇鑫IBC(A座)806室</span>
                  </li>
                  <li>
                    联系电话: <span>029-89181990</span>
                  </li>
                  <li>
                    公司邮箱: <span>info@zhongway.com</span>
                  </li>
                  <li>
                    公司邮编: <span>710065</span>
                  </li>
                  <li>
                    公司网址: <span>www.zhongway.com</span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getHonor } from '@/js/aboutUs'
import timeLine from '../components/timeLine'
import { getShowAdvert } from '@/js/carousel'
import { pictureBaseUrl } from '@/utils/request'
export default {
  name: 'AboutUs',
  // 注册组件
  components: {
    timeLine
  },
  data() {
    return {
      srcList: [],
      picUrl: '',
      pictureBaseUrl: pictureBaseUrl,
      activeName: '1',
      active: 0,
      developStep: 0,
      developList: [],
      ideaList: [
        {
          imgUrl: require('../assets/img/ssxyImg.png'),
          title: '7×24小时实时响应',
          context: '为您提供全天候、不间断的实时响应服务，用最短的时间、最优的团队、最佳方案去帮助您！'
        },
        {
          imgUrl: require('../assets/img/yczcfwImg.png'),
          title: '远程支持服务',
          context: '通过热线电话、微信、远程协助等服务方式为客户提供产品资讯、应用答疑、投诉受理等服务支持！'
        },
        {
          imgUrl: require('../assets/img/xczcfwImg.png'),
          title: '现场驻场服务',
          context: '无论您身在何处，我们都能提供专人现场驻场服务，用最短的距离，帮助您解决使用过程中的任何问题！'
        },
        {
          imgUrl: require('../assets/img/lsdzfwImg.png'),
          title: '量身定制服务',
          context: '根据您的需求，为您提供专属的量身定制服务，帮助您打造最优产品解决方案及配套服务方案！'
        }
      ],
      corpList: [
        // 同华为建立了生态合作伙伴关系，
        {
          context: '陕西鑫众为软件有限公司成立于2004年，总部位于西安，深耕政企数字化领域20余年，是专业从事数字化解决方案设计、研发、销售及运维服务的高新技术企业，主要面向政府和企业客户提供软件定制化服务，拥有190+专业团队、50+陕西区域服务网点，30+自主知识产权，累计服务300+政府及大型企业客户。'
        },
        {
          context: '公司致力于成为中国领先的财政行业数字化方案提供商，同华为、福建博思等头部科技公司建立生态合作伙伴关系，是财政部预算管理一体化系统参建单位、陕西预算管理一体化核心应用系统全省运维服务商、国家税务总局陕西省税务局信息服务平台建设服务商。'
        },
        {
          context: '先后承担了国家税务总局陕西省税务局金税三期四期短信服务平台、陕西财政云预算管理一体化系统、陕西财政数据标准化规范管理平台、陕西数字财政、陕西电信L2/L3上云等重要项目的开发实施和运维工作。'
        }
      ],
      corpListBold: [
        {
          context: '我们的愿景使命：以技术为引擎，赋能政企数智化转型，致力于成为行业领先的智慧生态服务商，与客户、奋斗者共筑未来。'
        }
      ],
      honorList: []
    }
  },
  created() {
    this.getShowAdvert()
    this.getHonor()
  },
  methods: {
    getShowAdvert() {
      getShowAdvert({ type: '6' }).then(res => {
        if (res && res.code === 200) {
          this.picUrl = res.data[0].url
        }
      })
    },
    getHonor() {
      getHonor().then(res => {
        if (res && res.code === 200) {
          this.honorList = []
          for (var i = 0; i < res.data.length; i++) {
            this.srcList.push(pictureBaseUrl + res.data[i].fileId)
            if (i === 0 || i % 4 === 0) {
              const honor = []
              honor.push({
                imgUrl: res.data[i].fileId,
                name: res.data[i].name
              })
              this.honorList.push(honor)
            } else {
              this.honorList[parseInt(i / 4)].push({
                imgUrl: res.data[i].fileId,
                name: res.data[i].name
              })
            }
          }
        }
      })
    },
    // 上一年
    handleLastYear() {
      if (this.developStep === 0) {
        this.developStep = 0
      } else {
        this.developStep--
      }
    },
    // 下一年
    handleNextYear() {
      if (this.developStep === this.developList.length - 1) {
        this.developStep = this.developList.length - 1
      } else {
        this.developStep++
      }
    }
  }
}
</script>

<style scoped>

</style>
